<template>
  <div class="contact-form__submit">
    <div
      v-if="showAcceptText"
      class="checkbox contact-form__accept"
      role="group"
      :aria-labelledby="`accept-label-${uid}`"
    >
      <input
        :id="`contact-form__accept-${uid}`"
        v-model="acceptModel"
        required
        type="checkbox"
        aria-required="true"
      />
      <label
        :id="`accept-label-${uid}`"
        class="marker"
        :for="`contact-form__accept-${uid}`"
        v-html="acceptText"
      />
    </div>

    <transition name="contact-form__reveal-error">
      <div v-if="hasErrors" class="contact-form__error" role="alert">
        <p class="errors" v-html="error" />
      </div>
    </transition>

    <div class="contact-form__submit">
      <button
        :class="{
          disabled: isDisabled,
          'btn-loader': loading,
        }"
        class="btn btn-cta"
        :aria-busy="loading"
        :aria-disabled="isDisabled"
      >
        {{ submitButtonText }}
        <loader :loading="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import Loader from 'Components/loader/Loader.vue';

export default {
  name: 'SubmitSection',

  components: {
    Loader,
  },

  setup() {
    return { uid: crypto.randomUUID().slice(0, 8) };
  },

  props: {
    accept: {
      type: Boolean,
      default: false,
    },
    acceptText: {
      type: String,
      default: '',
      required: true,
      validator: function (value) {
        // Basic XSS protection - reject if contains <script> tags
        return !value.includes('<script');
      },
    },
    error: {
      type: String,
      default: '',
      validator: function (value) {
        return !value.includes('<script');
      },
    },
    hasErrors: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showAcceptText: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      required: true,
    },
  },

  emits: ['update:accept'],

  computed: {
    acceptModel: {
      get() {
        return this.accept;
      },
      set(value) {
        this.$emit('update:accept', value);
      },
    },
  },
};
</script>
